import { TrpcProvider } from '@/trpc'
import React from 'react'

import { QueryClient } from '@tanstack/react-query'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { BrowserRouter } from 'react-router-dom'
import { Toaster } from '@/components/ui/sonner'


const asyncStoragePersister = createSyncStoragePersister({
    storage: window.localStorage,
})

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 0
        },
    }
})

const AppProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <BrowserRouter>
        <TrpcProvider>
            <PersistQueryClientProvider client={queryClient} persistOptions={{ persister: asyncStoragePersister }}>
                <Toaster />
                {children}
                <ReactQueryDevtools initialIsOpen={false} />
            </PersistQueryClientProvider>
        </TrpcProvider>
    </BrowserRouter>
  )
}

export default AppProvider